'use strict';

const axios = require('axios');

module.exports = (orderSummaryData) => {
    return {
        namespaced: true,
        state: { ...orderSummaryData },
        mutations: {
            setOrderSummaryData(state, orderSummaryData) {
                Object.assign(state, orderSummaryData);
            },
            updatePropertyValue(state, args) {
                const { propertyName, value } = args;
                state[propertyName] = value;
            }
        },
        actions: {
            removeLineItem({ state, commit, dispatch }, productId) {
                return axios({
                    method: 'post',
                    url: state.removeItemURL,
                    data: { productId },
                    headers: { 'Content-Type': 'application/json' },
                }).then((result) => {
                    if (result.status !== 200) {
                        return false;
                    }
                    commit('setOrderSummaryData', result.data.orderSummary);
                    commit('delivery/setDeliveryState', result.data.delivery, { root: true });
                    dispatch('payments/setGiftCardData', result.data.giftCardData, { root: true });
                    commit('error/setErrorMessage', result.data.delivery.exclusionResults.errorMessage, { root: true });
                }).catch((error) => {
                    if (error.response && error.response.status === 303 && error.response.data.redirectURL) {
                        window.location.replace(error.response.data.redirectURL);
                    }
                });
            }
        },
    };
};
